const handleSubmit = async (
  { description },
  { props: { artifact, handleClose, instanceId, updateShelfArtifact } }
) => {
  await updateShelfArtifact(artifact, description, instanceId)
  handleClose()
}

export default handleSubmit
